interface TriggerOptions {
    redirectUrl?: string;
    isDismissible?: boolean;
    isUndismissibleFromOutsideClick?: boolean;
    trackingLabel?: string;
}
export default (options: TriggerOptions = {}) => {
    window.document.dispatchEvent(
        new CustomEvent('UPDATE_OVERLAYS', {
            detail: {
                action: 'SHOW',
                id: 'CLUB_SIGNUP_OVERLAY',
                options,
            },
        })
    );
};
